// Deep merge utility to combine base and mode themes
export const deepMerge = (base, override) => {
  const result = { ...base };

  Object.entries(override || {}).forEach(([key, value]) => {
    if (value && typeof value === "object" && !Array.isArray(value)) {
      result[key] = deepMerge(result[key] || {}, value);
    } else {
      result[key] = value;
    }
  });

  return result;
};

export const generateCSSVariables = (baseTheme, modeTheme) => {
  if (!baseTheme && !modeTheme) return;

  // Deep merge base and mode themes (mode overrides base)
  const mergedTheme = deepMerge(baseTheme || {}, modeTheme || {});

  const vars = {};
  const EXCLUDED_KEYS = ["id", "assets"];

  const walk = (obj, prefix = "") => {
    Object.entries(obj).forEach(([key, value]) => {
      if (EXCLUDED_KEYS.includes(key)) return;
      const newKey = prefix ? `${prefix}-${key}` : key;

      if (typeof value === "object" && value !== null) {
        walk(value, newKey);
      } else {
        vars[`--${newKey}`] = value;
      }
    });
  };

  walk(mergedTheme);
  return vars;
};

export const applyCSSVariables = (vars) => {
  const root = document.documentElement;

  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};
